//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpDatas', {
//        templateUrl: 'views/components/views/discGrpDatas/discGrpDatas.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['ttGridFactory', function (ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_discgrpdatas_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setLoadDataFunction({
//                method: 3123,
//                parameters: {}
//            });

//            // #endregion VARIABLES & DEFINITIONS
            
//        }]
//    });
//})();
